import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../theme';

import {Button, ButtonGroup} from '@material-ui/core';

class TabbedMenu_ extends React.Component{

  handleClick(tab){
    if(this.props.onClick) 
    this.props.onClick(tab)
  }

  buttonStyle(name){
    const buttonStyle = {
      minWidth: '100px',
      minHeight: '2.0em',
      background: theme.palette.background.tabbedMenu,
      color: theme.palette.color.tabbedMenu
    } 
    if(this.props.selected===name){
      return {
        ...buttonStyle,
        background: theme.palette.background.tabbedMenuSelected
      }
    }else{
      return buttonStyle
    }

  }

  render(){
    const {t} = this.props

    return (
      <ButtonGroup size="small">
        <Button style={this.buttonStyle('external_servers')} 
            onClick={()=>this.handleClick('external_servers')}>{t('ExternalServers')}</Button>
      
        <Button style={this.buttonStyle('local_groups')} 
            onClick={()=>this.handleClick('local_groups')}>{t('LocalGroups')}</Button>

      </ButtonGroup>
    );
  }
}

export const TabbedMenu = withTranslation()(TabbedMenu_);